var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminHookups(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 14.1668C6.6665 13.7066 7.0396 13.3335 7.49984 13.3335H12.4998C12.9601 13.3335 13.3332 13.7066 13.3332 14.1668C13.3332 14.6271 12.9601 15.0002 12.4998 15.0002H7.49984C7.0396 15.0002 6.6665 14.6271 6.6665 14.1668Z",
    fill: "#5A6774"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 10.8333C6.6665 10.3731 7.0396 10 7.49984 10H12.4998C12.9601 10 13.3332 10.3731 13.3332 10.8333C13.3332 11.2936 12.9601 11.6667 12.4998 11.6667H7.49984C7.0396 11.6667 6.6665 11.2936 6.6665 10.8333Z",
    fill: "#5A6774"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 7.49984C6.6665 7.0396 7.0396 6.6665 7.49984 6.6665H8.33317C8.79341 6.6665 9.1665 7.0396 9.1665 7.49984C9.1665 7.96007 8.79341 8.33317 8.33317 8.33317H7.49984C7.0396 8.33317 6.6665 7.96007 6.6665 7.49984Z",
    fill: "#5A6774"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66683 3.33317C5.74635 3.33317 5.00016 4.07936 5.00016 4.99984V14.9998C5.00016 15.9203 5.74635 16.6665 6.66683 16.6665H13.3335C14.254 16.6665 15.0002 15.9203 15.0002 14.9998V7.35686C15.0002 7.13585 14.9124 6.92388 14.7561 6.7676L11.5657 3.57725C11.4094 3.42097 11.1975 3.33317 10.9765 3.33317H6.66683ZM3.3335 4.99984C3.3335 3.15889 4.82588 1.6665 6.66683 1.6665H10.9765C11.6395 1.6665 12.2754 1.9299 12.7442 2.39874L15.9346 5.58909C16.4034 6.05793 16.6668 6.69382 16.6668 7.35686V14.9998C16.6668 16.8408 15.1744 18.3332 13.3335 18.3332H6.66683C4.82588 18.3332 3.3335 16.8408 3.3335 14.9998V4.99984Z",
    fill: "#5A6774"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 2.5V4.16667C11.6667 5.54738 12.786 6.66667 14.1667 6.66667H15.8333V8.33333H14.1667C11.8655 8.33333 10 6.46785 10 4.16667V2.5H11.6667Z",
    fill: "#5A6774"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminHookups);
export default __webpack_public_path__ + "static/media/admin_hookups.c9711b1e71b48964fcc4e63f44bb2249.svg";
export { ForwardRef as ReactComponent };